import restaurantModalLoginInstance from '../../../modalLoginInstance'
import restaurantInstance from '../../../instance'

const updateWaiterNotificationStatus = (tableId, data, hasModalLogin = true) => {
	return (hasModalLogin ? restaurantModalLoginInstance : restaurantInstance)
		.put(`/tables/${tableId}/items/notificationStatus`, data)
}

export default updateWaiterNotificationStatus
